import {bignumber, BigNumber} from "mathjs";
import {divide} from "./api-mpms";
import {PressureUnit, PressureUnitBar, PressureUnitKpa, PressureUnitPsig,} from "./unit/pressure-unit";
import {UnitValue} from "./unit/unit";

export class Pressure extends UnitValue<PressureUnit> {

  to(unit: PressureUnit): Pressure {
    if (unit === PressureUnitPsig) {
      const convertedValue = Pressure.convertToPSIG(this)
      return new Pressure(convertedValue, unit)
    } else if (unit === PressureUnitKpa) {
      if (this.unit !== PressureUnitKpa) {
        throw new Error("Unable to convert pressure to kPa")
      }
      return new Pressure(bignumber(this.value), this.unit)
    } else if (unit === PressureUnitBar) {
      if (this.unit !== PressureUnitKpa) {
        throw new Error("Unable to convert pressure to bar")
      }
      return new Pressure(bignumber(this.value), this.unit)
    } else {
      throw new Error("Unknown unit: " + unit);
    }
  }

  rounded(): Pressure {
    const roundedValue = this.roundedValue()
    return new Pressure(roundedValue, this.unit)
  }

  static convertToPSIG(pressure: Pressure): BigNumber {
    if (pressure.unit === PressureUnitPsig) {
      return pressure.value
    } else if (pressure.unit === PressureUnitKpa) {
      return divide(pressure.value, bignumber("6.894757"))
    } else if (pressure.unit === PressureUnitBar) {
      return divide(pressure.value, bignumber("0.06894757"))
    } else {
      throw new Error("Unknown unit: " + pressure.unit)
    }
  }
}
